export default "__VITE_ASSET__e20fe285__"